<div *ngIf="loaded===false">
  <app-loading></app-loading>
</div>
<div *ngIf="loaded===true">
  <app-header [cmsMainSection]=cmsHeader [cultureSelected]=cultureKentico [cmsSEO]=cmsSEO></app-header>
  <app-refund-search [cmsMainSection]=cmsMainSection></app-refund-search>
  <app-footer [cmsMainSection]=cmsFooter></app-footer>
</div>
